var map = {
	"./bon-pari.png": 1360,
	"./comilfo.png": 6859,
	"./goodmix.png": 8521,
	"./hrutka.png": 3605,
	"./nuts.png": 1160,
	"./rodnye-prostory.png": 4020,
	"./rossia.png": 9885
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4687;